enum SharedEwaybillAccountType {
  JD = "JD",
  JDL = "JDL",

  JINRITEMAI = "JINRITEMAI",
  JINRITEMAI_AUTH = "JINRITEMAI_AUTH",

  OFFICIAL = "OFFICIAL",

  PDD = "PDD",
  PDD_AUTH = "PDD_AUTH",

  TAOBAO_CAINIAO_AUTH = "TAOBAO_CAINIAO_AUTH",

  KWAISHOP = "KWAISHOP",

  XIAOHONGSHU = "XIAOHONGSHU",
  CHANNEL_SHOP = "CHANNEL_SHOP",
}

export default SharedEwaybillAccountType;
